import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { useSelector } from 'react-redux'

import { Heading, Icon } from '@starbucks-web/pattern-library'
import DialogWithMessages from '../../../../../shared/app/components/dialog-with-messages/index.jsx'
import { sharedCallsToAction } from '../../../../../shared/app/messages/ctas.js'
import { accountDeleteOneTrustFormUrlSelector } from '../../../state/selectors.js'

export const ACCOUNT_DELETE_DIALOG_ID = 'AccountDeleteDialogId'

import { messages } from './messages.js'
import sharedMessages from '../../shared-messages.js'
import externalLinkMessages from '../../../../../shared/app/components/external-link/messages.js'
import { externalLink as externalLinkPath } from '@starbucks-web/pattern-library/icons'

export const AccountDeleteDialog = () => {
  const { formatMessage } = useIntl()
  const accountDeleteOneTrustFormUrl = useSelector(
    accountDeleteOneTrustFormUrlSelector
  )

  return (
    <DialogWithMessages
      cancelButtonProps={{
        color: 'black',
      }}
      cancelText={<FormattedMessage {...sharedCallsToAction.cancel} />}
      confirmButtonProps={{
        'aria-label': `${formatMessage(messages.deleteAccountDialogConfirm)}, ${formatMessage(externalLinkMessages.externalLinkAria)}`,
        className: 'flex items-center',
        color: 'red',
        href: accountDeleteOneTrustFormUrl,
        rel: 'noopener noreferrer',
        target: '_blank',
      }}
      confirmText={
        <React.Fragment>
          <FormattedMessage {...messages.deleteAccountDialogConfirm} />
          <Icon path={externalLinkPath} />
        </React.Fragment>
      }
    >
      <Heading
        className="pb3 text-semibold"
        id={ACCOUNT_DELETE_DIALOG_ID}
        size="md"
        tagName="h2"
      >
        <FormattedMessage {...messages.deleteAccountDialogHeader} />
      </Heading>
      <p>
        <FormattedMessage {...sharedMessages.accountDeleteDescription} />
      </p>
    </DialogWithMessages>
  )
}
export default AccountDeleteDialog
